import React, { Fragment, useState } from 'react'
import { Formik, Form, Field, ErrorMessage, getIn } from 'formik';
import { withRouter } from 'react-router-dom'
import estilos from './VerAnalisisFQComponent.module.css'

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { agregarAnalisis, actualizarAnalisis } from '../../../redux/DucksUnidadInspeccion/AnalisisFQDuck';
import { getInspectores } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck';

import { useEffect } from 'react';
import { subirArchivosLotes } from '../../../redux/DucksUnidadInspeccion/ArchivosDuck';
import { obtenerLaboratorios, agregarLaboratorio, actualizarLaboratorio } from '../../../redux/DucksUnidadInspeccion/LaboratorioDuck';

import { Store } from 'react-notifications-component';
import { Add, Edit } from '@mui/icons-material';
import { Box, Modal } from '@mui/material';


const FormularioFisicoQuimico = (props) => {

    const dispatch = useDispatch()

    const [inicialStateFormik, setInicialStateFormik] = useState({})
    const [laboratorios, setLaboratorios] = useState([])
    const [categoria, setCategoria] = useState(null);
    const [clase, setClase] = useState(null);
    const [cumple, setCumple] = useState(null);
    const [certificado, setCertificado] = useState(null);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [analsisSeleccionado, setAnalisisSeleccionado] = React.useState(null);
    const [laboratorioSeleccionado, setLaboratorioSeleccionado] = React.useState("null");
    const [openAñadirLaboratorio, setOpenAñadirLaboratorio] = React.useState(false);
    const [laboratorio, setLaboratorio] = React.useState([]);
    const inspectores = useSelector(store => store.Inspectores.inspectores);


    useEffect(() => {
        dispatch(obtenerLaboratorios()).then((res) => {
            setLaboratorios(res.payload.data.data)
        })
    }, [])


    useEffect(() => {

        var fechaActual = new Date();
        dispatch(getInspectores())   //inspectores

        const anio = fechaActual.getFullYear();
        const mes = String(fechaActual.getMonth() + 1).padStart(2, '0'); // Sumar 1 al mes ya que en JavaScript los meses van de 0 a 11
        const dia = String(fechaActual.getDate()).padStart(2, '0');

        const fechaActualFormateada = `${anio}-${mes}-${dia}`;

        if (props.analisis != undefined) {

            const fechaderegistroFormateada = fechaActualFormateada;

            //

            let fechadeemision = props.analisis.fechadeemision;

            let fechadeemisionnueva = new Date(fechadeemision);

            const aniofechadeemision = fechadeemisionnueva.getFullYear();
            const mesfechadeemision = String(fechadeemisionnueva.getMonth() + 1).padStart(2, '0'); // Sumar 1 al mes ya que en JavaScript los meses van de 0 a 11
            const diafechadeemision = String(fechadeemisionnueva.getDate() + 1).padStart(2, '0');

            const fechadeemisionFormateada = `${aniofechadeemision}-${mesfechadeemision}-${diafechadeemision}`;

            //

            let fechacpg = props.analisis.fechacpg;

            let fechacpgnueva = new Date(fechacpg);

            const aniofechacpg = fechacpgnueva.getFullYear();
            const mesfechacpg = String(fechacpgnueva.getMonth() + 1).padStart(2, '0'); // Sumar 1 al mes ya que en JavaScript los meses van de 0 a 11
            const diafechacpg = String(fechacpgnueva.getDate() == 31 ? 1 : fechacpgnueva.getDate() + 1).padStart(2, '0');

            const fechacpgFormateada = `${aniofechacpg}-${mesfechacpg}-${diafechacpg}`;

            //

            let fechadictamen = props.analisis.fechadictamen;

            let fechadictamennueva = new Date(fechadictamen);

            const aniofechadictamen = fechadictamennueva.getFullYear();
            const mesfechadictamen = String(fechadictamennueva.getMonth() + 1).padStart(2, '0'); // Sumar 1 al mes ya que en JavaScript los meses van de 0 a 11
            const diafechadictamen = String(fechadictamennueva.getDate() == 31 ? 1 : fechadictamennueva.getDate() + 1).padStart(2, '0');

            const fechadictamenFormateada = `${aniofechadictamen}-${mesfechadictamen}-${diafechadictamen}`;

            //

            let fechatrabajada = props.analisis.fechatrabajada;

            let fechatrabajadanueva = new Date(fechatrabajada);

            const aniofechatrabajada = fechatrabajadanueva.getFullYear();
            const mesfechatrabajada = String(fechatrabajadanueva.getMonth() + 1).padStart(2, '0'); // Sumar 1 al mes ya que en JavaScript los meses van de 0 a 11
            const diafechatrabajada = String(fechatrabajadanueva.getDate() == 31 ? 1 : fechatrabajadanueva.getDate() + 1).padStart(2, '0');

            const fechatrabajadaFormateada = `${aniofechatrabajada}-${mesfechatrabajada}-${diafechatrabajada}`;

            setInicialStateFormik(
                {
                    idanalisisfq: props.analisis.idanalisisfq,
                    numerocliente: props.clienteSeleccionado.numerosocio,
                    consecutivo: props.analisis.folio,
                    fecharegistroexcel: fechaderegistroFormateada,
                    fechaemision: fechadeemisionFormateada,
                    lote: props.loteSeleccionado,
                    idanalisisfisicoquimico: props.analisis.analisisfq,
                    alcoholvolumen20: props.analisis.columenalcohol,
                    extractoseco: props.analisis.estractoseco,
                    metanol: props.analisis.metanol,
                    alcoholessuperiores: props.analisis.alcoholessuperiores,
                    aldehídos: props.analisis.aldehidos,
                    furfural: props.analisis.furfural,
                    plomo: props.analisis.plomo,
                    arsenico: props.analisis.arsenico,
                    // fechaemisioncpg: fechacpgFormateada,
                    // observacionesoc: props.analisis.observacionesoc,
                    numerodictamen: props.analisis.numerodictamen,
                    fechaemisiondictamen: fechadictamenFormateada,
                    observacionesui: props.analisis.observacionesui,
                    folioUI: props.analisis.folioui,
                    inspector: props.analisis.inspector.idinspector,
                    fechatrabajada: fechatrabajadaFormateada,
                    categoría: props.analisis.categoriamezcal,
                    clase: props.analisis.clase,
                    cumpleono: props.analisis.cumple == true ? 1 : 2,
                    // certificadoAGranel: props.analisis.certificadogranel == true ? 1 : 2,
                    norma: props.analisis.norma,
                    laboratorio: props.analisis.laboratorio,
                    volumen: props.analisis.volumen,
                    años: props.analisis.anios,
                    meses: props.analisis.meses,
                    ingrediente: props.analisis.ingrediente
                })
        } else {
            setInicialStateFormik(
                {
                    numerocliente: props.clienteSeleccionado.numerosocio,
                    consecutivo: '',
                    fecharegistroexcel: fechaActualFormateada,
                    fechaemision: '',
                    lote: props.loteSeleccionado,
                    idanalisisfisicoquimico: '',
                    alcoholvolumen20: '',
                    extractoseco: '',
                    metanol: '',
                    alcoholessuperiores: '',
                    aldehídos: '',
                    furfural: '',
                    plomo: '',
                    arsenico: '',
                    fechaemisioncpg: '',
                    observacionesoc: '',
                    numerodictamen: '',
                    fechaemisiondictamen: '',
                    observacionesui: '',
                    folioUI: '',
                    inspector: '',
                    fechatrabajada: '',
                    categoría: '',
                    clase: '',
                    cumpleono: 2,
                    certificadoAGranel: '',
                    norma: '',
                    laboratorio: '',
                    volumen: '',
                    años: 0,
                    meses: 0,
                    ingrediente: ''
                })
        }
    }, [props.analisis])

    const handleChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const subirArchivo = () => {
        if (selectedFile != null) {

            const data = {
                idcliente: clienteSeleccionado.idcliente,
                lote: loteSeleccionado,
                file: selectedFile,
                analisis: analsisSeleccionado.analisisfq
            }
            dispatch(subirArchivosLotes(data))
            setSelectedFile(null)
        }
    }

    function convertirValor(value) {
        var match = value.match(/[0-9]+(\.[0-9]+)?/);
        if (match) {
            return parseFloat(match[0]);
        } else {
            return NaN; // Maneja casos en los que no se encuentren números
        }
    }

    function isInRange_35_55(value) {
        return convertirValor(value) >= 35 && convertirValor(value) <= 55;
    }

    function isInRange_100_500(value) {
        return convertirValor(value) >= 100 && convertirValor(value) <= 500;
    }

    function isInRange_0_10(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 10;
    }

    function isInRange_30_300(value) {
        return convertirValor(value) >= 30 && convertirValor(value) <= 300;
    }

    function isInRange_0_5(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 5;
    }

    function isInRange_0_40(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 40;
    }

    function isInRange_0_0_5(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 0.5;
    }

    function isInRange_0_0_5_alt(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 0.5;
    }

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 600, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center', overflow: 'scroll', height: '45%'
    };

    const handleOpenModalAñadirLaboratorio = () => {
        setOpenAñadirLaboratorio(true)
    }

    const handleCloseModalAñadirLaboratorio = () => {
        setLaboratorioSeleccionado("null");
        setOpenAñadirLaboratorio(false)
    }

    useEffect(() => {
        setLaboratorio(laboratorios.filter(l => l.idlaboratorio == Number(laboratorioSeleccionado)))
    }, [laboratorioSeleccionado])

    useEffect(() => {
        setInputValue(laboratorio[0]?.nombre)
    }, [laboratorio])

    const [inputValue, setInputValue] = useState();

    const guardarDatosLaboratorio = () => {
        if (!inputValue) {
            handleOpenErrorLaboratorio()
        } else {
            if (isNaN(Number(laboratorioSeleccionado))) {

                const data = {
                    data: {
                        nombre: inputValue
                    }
                }
                dispatch(agregarLaboratorio(data))
                setLaboratorioSeleccionado("null");
                setInputValue("")
                dispatch(actualizarLaboratorio(data)).then((r) => {
                    dispatch(obtenerLaboratorios()).then((res) => {
                        setLaboratorios(res.payload.data.data)
                    })
                })
                handleCloseModalAñadirLaboratorio()
            } else {
                const data = {
                    data: {
                        idlaboratorio: laboratorio[0]?.idlaboratorio,
                        nombre: inputValue,
                    }
                }

                dispatch(actualizarLaboratorio(data)).then((r) => {
                    dispatch(obtenerLaboratorios()).then((res) => {
                        setLaboratorios(res.payload.data.data)
                    })
                })
                setLaboratorioSeleccionado("null");
                setInputValue("")
                handleCloseModalAñadirLaboratorio()
            }
        }
    }

    const HTMLAbrirAñadirlaboratorio = () => {
        return (
            <Modal
                open={openAñadirLaboratorio}
                onClose={handleCloseModalAñadirLaboratorio}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={style} >
                    <div className="col">
                        <h4>{isNaN(Number(laboratorioSeleccionado)) ? "Añadir Laboratorio" : "Actualizar Laboratorio"}</h4>
                        <input type="text" className="form-control" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                        <br />
                        <br />
                        <button className='btn btn-success' onClick={guardarDatosLaboratorio}>Guardar</button>
                    </div>
                </Box>

            </Modal>
        )
    }

    const [openErrorLaboratorio, setOpenErrorLaboratorio] = React.useState(false);

    const handleOpenErrorLaboratorio = () => {
        setOpenErrorLaboratorio(true)
    };
    const handleCloseErrorLaboratorio = () => setOpenErrorLaboratorio(false);

    const styleBox = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const modalErrorLaboratorio = () => {
        return (
            <Modal
                open={openErrorLaboratorio}
                onClose={handleCloseErrorLaboratorio}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleBox}>
                    <div className='text-center'>
                        Debe ingresar un nuevo nombre para el laboratorio<br /><br />
                        <button className='btn btn-danger' onClick={() => handleCloseErrorLaboratorio()}> Aceptar</button>
                    </div>
                </Box>
            </Modal>
        )
    }

    return (
        <Fragment>
            <div className='row'>
                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12`}>
                    <div className='row'>

                    </div>
                    <Formik
                        initialValues={inicialStateFormik}
                        enableReinitialize={true}
                        validate={values => {
                            const errors = {};

                            if (isInRange_35_55(values.alcoholvolumen20) && isInRange_0_10(values.extractoseco) && isInRange_30_300(values.metanol) && isInRange_100_500(values.alcoholessuperiores) && isInRange_0_40(values.aldehídos) && isInRange_0_5(values.furfural) && isInRange_0_0_5(values.plomo) && isInRange_0_0_5(values.arsenico)) {
                                values.cumpleono = 1
                            } else {
                                values.cumpleono = 2
                            }

                            if (!values.numerocliente) {
                                errors.numerocliente = 'Campo requerido';
                            }

                            // if (!values.consecutivo) {
                            //     errors.consecutivo = 'Campo requerido';
                            // }

                            if (!values.fecharegistroexcel) {
                                errors.fecharegistroexcel = 'Campo requerido';
                            }

                            if (!values.fechaemision) {
                                errors.fechaemision = 'Campo requerido';
                            }

                            if (!values.lote) {
                                errors.lote = 'Campo requerido';
                            }

                            if (!values.idanalisisfisicoquimico) {
                                errors.idanalisisfisicoquimico = 'Campo requerido';
                            }

                            if (!values.alcoholvolumen20) {
                                errors.alcoholvolumen20 = 'Campo requerido';
                            }

                            if (!values.extractoseco) {
                                errors.extractoseco = 'Campo requerido';
                            }

                            if (!values.metanol) {
                                errors.metanol = 'Campo requerido';
                            }

                            if (!values.alcoholessuperiores) {
                                errors.alcoholessuperiores = 'Campo requerido';
                            }

                            if (!values.aldehídos) {
                                errors.aldehídos = 'Campo requerido';
                            }

                            if (!values.furfural) {
                                errors.furfural = 'Campo requerido';
                            }

                            if (!values.plomo) {
                                errors.plomo = 'Campo requerido';
                            }

                            // if (!values.numerodictamen) {
                            //     errors.numerodictamen = 'Campo requerido';
                            // }

                            // if (!values.fechaemisiondictamen) {
                            //     errors.fechaemisiondictamen = 'Campo requerido';
                            // }

                            if (!values.observacionesui) {
                                errors.observacionesui = 'Campo requerido';
                            }

                            if (!values.folioUI) {
                                errors.folioUI = 'Campo requerido';
                            }

                            if (!values.inspector) {
                                errors.inspector = 'Campo requerido';
                            }

                            if (!values.fechatrabajada) {
                                errors.fechatrabajada = 'Campo requerido';
                            }

                            if (!values.categoría) {
                                errors.categoría = 'Campo requerido';
                            }

                            if (!values.clase) {
                                errors.clase = 'Campo requerido';
                            }

                            if (!values.cumpleono) {
                                errors.cumpleono = 'Campo requerido';
                            }

                            if (!values.laboratorio) {
                                errors.laboratorio = 'Campo requerido';
                            } else {
                                setLaboratorioSeleccionado(values.laboratorio)
                            }

                            return errors;
                        }}
                        onSubmit={(values) => {

                            let fechaderegistroformat = new Date(values.fecharegistroexcel);
                            fechaderegistroformat.setDate(fechaderegistroformat.getDate() + 1);

                            let fechaemisionformat = new Date(values.fechaemision);
                            fechaemisionformat.setDate(fechaemisionformat.getDate() + 1);

                            let fechaemisiondictamenformat = new Date(values.fechaemisiondictamen);
                            fechaemisiondictamenformat.setDate(fechaemisiondictamenformat.getDate() + 1);

                            let fechatrabajadaformat = new Date(values.fechatrabajada);
                            fechatrabajadaformat.setDate(fechatrabajadaformat.getDate() + 1);

                            let fechaemisioncpgformat = new Date(values.fechaemisioncpg);
                            fechaemisioncpgformat.setDate(fechaemisioncpgformat.getDate() + 1);

                            if (props.analisis != undefined) {

                                const data = {
                                    data: {
                                        idanalisisfq: values.idanalisisfq,
                                        numerocliente: values.numerocliente,
                                        folio: Number(values.consecutivo),
                                        fechaderegistro: fechaderegistroformat,
                                        fechadeemision: fechaemisionformat,
                                        lote: props.loteSeleccionado,
                                        analisisfq: values.idanalisisfisicoquimico,
                                        columenalcohol: values.alcoholvolumen20,
                                        estractoseco: values.extractoseco,
                                        metanol: values.metanol,
                                        alcoholessuperiores: values.alcoholessuperiores,
                                        aldehidos: values.aldehídos,
                                        furfural: values.furfural,
                                        plomo: values.plomo,
                                        arsenico: values.arsenico,
                                        // fechacpg: fechaemisioncpgformat,
                                        // observacionesoc: values.observacionesoc,
                                        numerodictamen: values.numerodictamen,
                                        fechadictamen: fechaemisiondictamenformat,
                                        observacionesui: values.observacionesui,
                                        folioui: values.folioUI,
                                        idinspector: Number(values.inspector),
                                        fechatrabajada: fechatrabajadaformat,
                                        categoriamezcal: values.categoría,
                                        clase: values.clase,
                                        cumple: Number(values.cumpleono) == 1 ? true : false,
                                        // certificadogranel: Number(values.certificadoAGranel) == 1 ? true : false,
                                        norma: values.norma,
                                        idlaboratorio: Number(values.laboratorio),
                                        volumen: values.volumen,
                                        anios: values.años,
                                        meses: values.meses,
                                        ingrediente: values.ingrediente,
                                    }
                                }

                                dispatch(actualizarAnalisis(data)).then((res) => {
                                    props.actualizarAnalisis()
                                    props.cerrarVisualizacion()
                                    props.cerrar()
                                    props.cerrarModalAnalisis()
                                    Store.addNotification({
                                        title: "Informacion guardada correctamente!",
                                        message: "Guardado Correctamente",
                                        type: "success",
                                        insert: "top",
                                        container: "top-center",
                                        animationIn: ["animate__animated", "animate__fadeIn"],
                                        animationOut: ["animate__animated", "animate__fadeOut"],
                                        dismiss: {
                                            duration: 5000,
                                            onScreen: true
                                        }
                                    });
                                })
                                // //ESTE METODO NO SE SI VA AQUI
                                // subirArchivo()

                            } else {
                                const data = {
                                    data: {
                                        numerocliente: values.numerocliente,
                                        folio: Number(values.consecutivo),
                                        fechaderegistro: fechaderegistroformat,
                                        fechadeemision: fechaemisionformat,
                                        lote: props.loteSeleccionado,
                                        analisisfq: values.idanalisisfisicoquimico,
                                        columenalcohol: values.alcoholvolumen20,
                                        estractoseco: values.extractoseco,
                                        metanol: values.metanol,
                                        alcoholessuperiores: values.alcoholessuperiores,
                                        aldehidos: values.aldehídos,
                                        furfural: values.furfural,
                                        plomo: values.plomo,
                                        arsenico: values.arsenico,
                                        // fechacpg: fechaemisioncpgformat,
                                        // observacionesoc: values.observacionesoc,
                                        numerodictamen: values.numerodictamen,
                                        fechadictamen: fechaemisiondictamenformat,
                                        observacionesui: values.observacionesui,
                                        folioui: values.folioUI,
                                        idinspector: Number(values.inspector),
                                        fechatrabajada: fechatrabajadaformat,
                                        categoriamezcal: values.categoría,
                                        clase: values.clase,
                                        cumple: Number(values.cumpleono) == 1 ? true : false,
                                        // certificadogranel: Number(values.certificadoAGranel) == 1 ? true : false,
                                        norma: values.norma,
                                        idlaboratorio: Number(values.laboratorio),
                                        volumen: values.volumen,
                                        anios: values.años,
                                        meses: values.meses,
                                        ingrediente: values.ingrediente,
                                    }
                                }

                                dispatch(agregarAnalisis(data))
                                props.actualizarAnalisis()
                                props.cerrar()
                                props.cerrarModalAnalisis()
                                Store.addNotification({
                                    title: "Informacion guardada correctamente!",
                                    message: "Guardado Correctamente",
                                    type: "success",
                                    insert: "top",
                                    container: "top-center",
                                    animationIn: ["animate__animated", "animate__fadeIn"],
                                    animationOut: ["animate__animated", "animate__fadeOut"],
                                    dismiss: {
                                        duration: 5000,
                                        onScreen: true
                                    }
                                });
                                // subirArchivo()
                            }
                        }}
                    >
                        {({ values }) => (
                            <Form>
                                <div className={`container`}>
                                    <h2 className={`text-center ${estilos.labelVerde}`}>Lote: {props.loteSeleccionado}</h2>

                                    <br />
                                    <Field required type="hidden" name="id" className='form-control' />
                                    <div className='row'>
                                        <div className='col-4'>
                                            <label htmlFor="numerocliente">Número de Cliente:</label><br />
                                            <Field required type="text" name="numerocliente" className='form-control'>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="numerocliente" component="div" /><br />
                                        </div>

                                        <div className='col-4'>
                                            <label htmlFor="fecharegistroexcel">Fecha de registro:</label><br />
                                            <Field disabled type="date" name="fecharegistroexcel" className='form-control'>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="fecharegistroexcel" component="div" /><br />
                                        </div>
                                        <div className='col-4'>
                                            <label htmlFor="clase">Clase:</label><br />
                                            <Field required as="select" name="clase" className='form-select' multiple={false} >
                                                <option value="" disabled selected>Seleccione una Clase</option>
                                                <option value={"Blanco o Joven"}>Blanco o Joven</option>
                                                <option value={"Madurado en vidrio"}>Madurado en vidrio</option>
                                                <option value={"Reposado"}>Reposado</option>
                                                <option value={"Añejo"}>Añejo</option>
                                                <option value={"Abocado con"}>Abocado con</option>
                                                <option value={"Destilado con"}>Destilado con</option>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="clase" component="div" /><br />
                                        </div>
                                    </div>
                                    {
                                        values.clase ?
                                            <div className='row'>
                                                {
                                                    values.clase == "Madurado en vidrio" ?
                                                        <div className='col-4'>
                                                            <label htmlFor="años">Años:</label><br />
                                                            <Field required type="number" name="años" className='form-control'>
                                                            </Field>
                                                            <ErrorMessage style={{ color: 'red' }} name="años" component="div" /><br />
                                                        </div>
                                                        :
                                                        values.clase == "Reposado" ?
                                                            <div className='col-4'>
                                                                <label htmlFor="meses">Meses:</label><br />
                                                                <Field required type="number" name="meses" className='form-control'>
                                                                </Field>
                                                                <ErrorMessage style={{ color: 'red' }} name="meses" component="div" /><br />
                                                            </div>
                                                            :
                                                            values.clase == "Añejo" ?
                                                                <div className='col-4'>
                                                                    <label htmlFor="años">Años:</label><br />
                                                                    <Field required type="number" name="años" className='form-control'>
                                                                    </Field>
                                                                    <ErrorMessage style={{ color: 'red' }} name="años" component="div" /><br />
                                                                </div>
                                                                :
                                                                values.clase == "Abocado con" ?
                                                                    <div className='col-4'>
                                                                        <label htmlFor="ingrediente">Ingrediente:</label><br />
                                                                        <Field required type="text" name="ingrediente" className='form-control'>
                                                                        </Field>
                                                                        <ErrorMessage style={{ color: 'red' }} name="ingrediente" component="div" /><br />
                                                                    </div>
                                                                    :
                                                                    values.clase == "Destilado con" ?
                                                                        <div className='col-4'>
                                                                            <label htmlFor="ingrediente">Ingrediente:</label><br />
                                                                            <Field required type="text" name="ingrediente" className='form-control'>
                                                                            </Field>
                                                                            <ErrorMessage style={{ color: 'red' }} name="ingrediente" component="div" /><br />
                                                                        </div>
                                                                        :
                                                                        <Fragment></Fragment>
                                                }
                                            </div>
                                            :
                                            <Fragment />
                                    }
                                    <div className='row'>
                                        <div className='col-4'>
                                            <label htmlFor="fechaemision">Fecha de Emisión FQ:</label><br />
                                            <Field required type="date" name="fechaemision" className='form-control'>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="fechaemision" component="div" /><br />
                                        </div>
                                        <div className='col-4'>
                                            <label htmlFor="lote">Lote:</label><br />
                                            <Field required type="text" name="lote" className='form-control'>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="lote" component="div" /><br />
                                        </div>
                                        <div className='col-4'>
                                            <label htmlFor="categoría">Categoría de Mezcal:</label><br />
                                            <Field required as="select" name="categoría" className='form-select' multiple={false}>
                                                <option value="" disabled selected>Seleccione una Categoria de Mezcal</option>
                                                <option value={"Mezcal"}>Mezcal</option>
                                                <option value={"Mezcal Ancestral"}>Mezcal Ancestral</option>
                                                <option value={"Mezcal Artesanal"}>Mezcal Artesanal</option>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="categoría" component="div" /><br />
                                        </div>

                                    </div>
                                    <br /><hr />
                                    <div className='text-center'><h2 className={`text-center ${estilos.labelVerde}`}>Análisis Físico Químico</h2></div><hr />
                                    <div className='row'>
                                        <div className='col-3'>
                                            <label htmlFor="idanalisisfisicoquimico">Análisis Físico Químico:</label><br />
                                            <Field required type="text" name="idanalisisfisicoquimico" className='form-control'>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="idanalisisfisicoquimico" component="div" /><br />
                                        </div>
                                        <div className='col-3'>
                                            <label htmlFor="alcoholvolumen20">Alcohol Vol. a 20° C:</label><br />
                                            <Field required type="text" name="alcoholvolumen20" className='form-control'>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="alcoholvolumen20" component="div" /><br />
                                        </div>
                                        <div className='col-3'>
                                            <label htmlFor="extractoseco">Estracto Seco:</label><br />
                                            <Field required type="text" name="extractoseco" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="extractoseco" component="div" /><br />
                                        </div>
                                        <div className='col-3'>
                                            <label htmlFor="metanol">Metanol:</label><br />
                                            <Field required type="text" name="metanol" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="metanol" component="div" /><br />
                                        </div>
                                    </div>
                                    <div className='row'>

                                    </div> <br />
                                    <div className='row'>
                                        <div className='col-3'>
                                            <label htmlFor="alcoholessuperiores">Alcoholes Superiores:</label><br />
                                            <Field required type="text" name="alcoholessuperiores" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="alcoholessuperiores" component="div" /><br />
                                        </div>
                                        <div className='col-3'>
                                            <label htmlFor="aldehídos">Aldehídos:</label><br />
                                            <Field required type="text" name="aldehídos" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="aldehídos" component="div" /><br />
                                        </div>
                                        <div className='col-3'>
                                            <label htmlFor="furfural">Furfural:</label><br />
                                            <Field required type="text" name="furfural" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="furfural" component="div" /><br />
                                        </div>
                                        <div className='col-3'>
                                            <label htmlFor="plomo">Plomo:</label><br />
                                            <Field required type="text" name="plomo" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="plomo" component="div" /><br />
                                        </div>
                                    </div><br />
                                    <div className='row'>
                                        <div className='col-3'>
                                            <label htmlFor="arsenico">Arsénico:</label><br />
                                            <Field required type="text" name="arsenico" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="arsenico" component="div" /><br />
                                        </div>

                                        <div className='col-3'>
                                            <label htmlFor="cumpleono">Cumple / No cumple:</label><br />
                                            <Field required as="select" name="cumpleono" className='form-select' multiple={false} disabled >
                                                <option value="" disabled selected>CUMPLE/NO CUMPLE</option>
                                                <option value={1} >CUMPLE</option>
                                                <option value={2} >NO CUMPLE</option>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="cumpleono" component="div" /><br />
                                        </div>
                                        <div className='col-3'>
                                            <label htmlFor="numerodictamen">Número de Dictámen:</label><br />
                                            <Field type="text" name="numerodictamen" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="numerodictamen" component="div" /><br />
                                        </div>

                                        <div className='col-3'>
                                            <label htmlFor="fechaemisiondictamen">Fecha Emisión Dictámen:</label><br />
                                            <Field type="date" name="fechaemisiondictamen" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="fechaemisiondictamen" component="div" /><br />
                                        </div>
                                    </div><br />
                                    <div className='row'>
                                        <div className='col-4'>
                                            <label htmlFor="norma">Norma:</label><br />
                                            <Field required type="text" name="norma" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="norma" component="div" /><br />
                                        </div>
                                        <div className='col-4'>
                                            <label htmlFor="laboratorio">Laboratorio:</label><br />
                                            <div style={{ display: 'flex' }}>
                                                <Field required as="select" name="laboratorio" className='form-select' multiple={false}>

                                                    <option value={null} selected>Seleccione un Laboratorio</option>
                                                    {
                                                        laboratorios.map((l, index) => {
                                                            return (
                                                                <option key={index} value={l.idlaboratorio}>{l.nombre}</option>
                                                            )
                                                        })
                                                    }
                                                </Field>
                                                <button className='btn btn-sm btn-success' onClick={handleOpenModalAñadirLaboratorio}>{isNaN(Number(laboratorioSeleccionado)) ? <Add></Add> : <Edit></Edit>}</button>
                                            </div>
                                            <ErrorMessage style={{ color: 'red' }} name="laboratorio" component="div" /><br />
                                        </div>
                                        <div className='col-4'>
                                            <label htmlFor="volumen">Volumen:</label><br />
                                            <Field required type="text" name="volumen" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="volumen" component="div" /><br />
                                        </div>
                                    </div><br />
                                    {/* <div className='row'>
                                        <div className='col-6'>
                                            <label htmlFor="certificadoAGranel">Certificado a granel:</label><br />
                                            <Field required as="select" name="certificadoAGranel" className='form-select' multiple={false} >
                                                <option defaultValue>SI / NO</option>
                                                <option value={1}>SI</option>
                                                <option value={1}>NO</option>
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="certificadoAGranel" component="div" /><br />
                                        </div>

                                        <div className='col-6'>
                                            <label htmlFor="fechaemisioncpg">Fecha de Emisión CPG:</label><br />
                                            <Field required type="date" name="fechaemisioncpg" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="fechaemisioncpg" component="div" /><br />
                                        </div>
                                    </div><br /> */}
                                    <div className='row'>
                                        {/* <div className='col-6'>
                                            <label htmlFor="fechaemisioncpg">Fecha emisión CPG:</label><br />
                                            <Field required type="date" name="fechaemisioncpg" className='form-control' >
                                            </Field>
                                        </div> */}

                                        {/* <div className='col-6'>
                                            <label htmlFor="observacionesoc">Observaciones OC:</label><br />
                                            <Field required type="text" name="observacionesoc" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="observacionesoc" component="div" /><br />
                                        </div> */}
                                    </div>
                                    <div className='row'>
                                        <div className='col-6'>
                                            <label htmlFor="observacionesui">Observaciones UI:</label><br />
                                            <Field required type="textarea" rows={10} cols={40} name="observacionesui" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="observacionesui" component="div" /><br />
                                        </div>
                                        <div className='col-6'>
                                            <label htmlFor="fechatrabajada">Fecha de Muestreo:</label><br />
                                            <Field required type="date" name="fechatrabajada" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="fechatrabajada" component="div" /><br />
                                        </div>
                                        <br /><br /><br />
                                        <div className='col-4'>
                                            <label htmlFor="folioUI">Folio UI:</label><br />
                                            <Field required type="text" name="folioUI" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="folioUI" component="div" /><br />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label>Inspector</label>
                                            <Field
                                                component="select"
                                                id="inspectorseleccionado"
                                                name="inspector"

                                                className="form-select"
                                                multiple={false}
                                                required

                                            >
                                                <option value="" disabled>Seleccione Inspector</option>
                                                {inspectores.map((inspector, index) => {
                                                    return (
                                                        <option key={index} value={inspector.idinspector}>{inspector.titulo + " " + inspector.nombre + " " + inspector.apellidos}</option>

                                                    )


                                                })}
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="inspector" component="div" /><br />
                                        </div>


                                        {/* <div className='col-4'>
                                            <label htmlFor="inspector">Inspector:</label><br />
                                            <Field required type="text" name="inspector" className='form-control' >
                                            </Field>
                                            <ErrorMessage style={{ color: 'red' }} name="inspector" component="div" /><br />
                                        </div> */}

                                        {/* <div>
                                            <hr />
                                            <div className="mb-3">
                                                <h3 className={`text-center ${estilos.labelVerde} mb-3` }>Archivos</h3>
                                                <label htmlFor="formFileSm" className="form-label">Subir Analisis de Laboratorio relacionados</label>
                                                <input className="form-control form-control-sm" id="formFileSm" type="file" accept="application/pdf" onChange={handleChange} />
                                                <br />
                                            </div>
                                        </div> */}

                                    </div>


                                    <div className='text-center mt-5'>
                                        <button type="submit" className='btn btn-lg btn-success'>
                                            {props.analisis != undefined ?
                                                "Actualizar Análisis Físico Químico"
                                                :
                                                "Agregar Análisis Físico Químico"
                                            }
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}

                    </Formik>
                </div>
            </div>
            {HTMLAbrirAñadirlaboratorio()}
            {modalErrorLaboratorio()}
        </Fragment>
    )
}

export default withRouter(FormularioFisicoQuimico)